const t = {
  button: "button"
}, c = {
  click: "click",
  submit: "submit"
};
export {
  c as AMPLITUDE_ACTION,
  t as AMPLITUDE_LABEL
};
//# sourceMappingURL=amplitude.mjs.map
